import show from "./show";

export default {
  namespaced: true,
  modules: {
    show,
  },
};
